// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sliders-container .swiper {
  max-width: 100% !important;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 10000 !important;
}

/* @media (max-width: 1000px) {
  .parent-div{
    display: none;
  }
} */

.large-parent-div-1 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.large-parent-div {
  max-width: 1500px;
}

.large-sliders-container {
  padding-left: 50px;
  padding-right: 50px;
}

.large-sliders-container .swiper {
  max-width: 80%;
  max-height: 570px;
  padding-bottom: 15px;
  /* padding-left: 50px;
  padding-right: 50px; */
}

.large-parent-div .large-sliders-container .top-header {
  max-height: 90px;
  padding-left: 190px;
  padding-right: 170px;
}

.large-parent-div .large-sliders-container .result-component {
  max-height: 449px;
  margin-top: 0px;
}

.bg-light {
  background-color: #fff !important;
}

.sliders-container .swiper-button-next {
  margin-right: -8px !important;
  z-index: 10000 !important;
}

.sliders-container .swiper-button-prev {
  margin-left: -8px !important;
  z-index: 10000 !important;
}

.sliders-container .swiper-button-next,
.sliders-container .swiper-button-prev {
  width: 26px !important;
  height: 26px !important;
  border-radius: 50%;
  border: 1px solid #bbb !important;
  color: #31a6ee !important;
  background-color: #dadada;
}

.sliders-container .swiper-button-next:after,
.sliders-container .swiper-button-prev:after {
  font-size: 14px !important;
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
}

.large-parent-div .mySwiper {
  padding: 0px 0;
  overflow: visible;
}

.large-parent-div .swiper-slide-active {
  opacity: 1;
  z-index: 2;
  background-color: transparent !important;
}

.large-parent-div .swiper-slide-prev {
  opacity: 0.7;
  position: relative;
  left: 14rem;
  bottom: 5rem;
}

.result-page-card .large-result-component .large {
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  background-color: transparent !important;
}

.large-card {
  background-color: transparent !important;
}

.large-parent-div .swiper-slide-next {
  opacity: 0.7;
  position: relative;
  right: 14rem;
  bottom: 5rem;
}

.large-parent-div .slide-content {
  border-radius: 20px;
  transition: all 0.3s ease;
  height: 100%;
}

.large-parent-div .swiper-container {
  overflow: visible;
}

.sliders-container .swiper-pagination {
  display: flex !important;
  justify-content: space-between !important;
  max-width: 392px !important;
  left: 2.88rem !important;
  height: 30px;
  top: 7rem !important;
  z-index: 1 !important;
}

/* if back button is not availble use this for pagination adjustment */
.sliders-container.doktor-swiper-pagination .swiper-pagination {
  display: flex !important;
  justify-content: space-between !important;
  max-width: 392px !important;
  left: 2.88rem !important;
  height: 30px;
  top: 6rem !important;
  z-index: 1 !important;
}

.sliders-container .swiper-pagination-bullet {
  border-radius: 0 !important;
  width: 100% !important;
  height: 3.33px !important;
}

.sliders-container .swiper-pagination-bullet:hover,
.sliders-container .swiper-pagination-bullet-active {
  background: #717171 !important;
}
.large-sliders-container .swiper-button-next {
  margin-right: -8px !important;
  z-index: 10000 !important;
}

.large-sliders-container .swiper-button-prev {
  margin-left: -8px !important;
  z-index: 10000 !important;
}

.large-sliders-container .swiper-button-next,
.large-sliders-container .swiper-button-prev {
  width: 26px !important;
  height: 26px !important;
  border-radius: 50%;
  border: 1px solid #bbb !important;
  color: #fff !important;
  background-color: #b1aaaa;
}

.large {
  min-width: 400px;
  height: 300px;
  padding: 0px;
}

.large-sliders-container .swiper-button-next:after,
.large-sliders-container .swiper-button-prev:after {
  font-size: 14px !important;
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
}

.large-sliders-container .swiper-pagination {
  display: flex !important;
  justify-content: space-between !important;
  min-width: 100% !important;
  left: 2.88rem !important;
  height: 30px;
  top: 1px !important;
  z-index: 1 !important;
}

.large-sliders-container .swiper-pagination-bullet {
  border-radius: 0 !important;
  width: 100% !important;
  height: 3.33px !important;
}

.large-sliders-container .swiper-pagination-bullet:hover,
.large-sliders-container .swiper-pagination-bullet-active {
  background: #717171 !important;
}

.sliders-container .swiper-slide {
  transform: translate3d(10px) !important;
}

/* this will handle pagination line distance from top when given condition met */
@media (min-width: 500px) and (max-width: 1200px) {
  .sliders-container .swiper-pagination {
    top: 121px !important;
  }
}
@media (max-width: 500px) {
  .sliders-container .swiper-button-next,
  .sliders-container .swiper-button-prev {
    display: none !important;
  }

  .sliders-container .swiper {
    max-width: 100% !important;
  }

  .sliders-container .swiper-pagination {
    max-width: 87% !important;
    left: 1.66rem !important;
    top: 96px !important;
    height: 30px;
  }

  /* if back button is not availble use this for pagination adjustment */
  .sliders-container.doktor-swiper-pagination .swiper-pagination {
    max-width: 87% !important;
    left: 1.66rem !important;
    /* top: 4rem !important; */
    top: 60px !important;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Results/styles.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;GAIG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB;wBACsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;;iCAE+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;EACE,wBAAwB;EACxB,yCAAyC;EACzC,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,0BAA0B;EAC1B,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,gFAAgF;AAChF;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;IACpB,YAAY;EACd;;EAEA,sEAAsE;EACtE;IACE,yBAAyB;IACzB,wBAAwB;IACxB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;EACrB;AACF","sourcesContent":[".sliders-container .swiper {\n  max-width: 100% !important;\n  height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  z-index: 10000 !important;\n}\n\n/* @media (max-width: 1000px) {\n  .parent-div{\n    display: none;\n  }\n} */\n\n.large-parent-div-1 {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.large-parent-div {\n  max-width: 1500px;\n}\n\n.large-sliders-container {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.large-sliders-container .swiper {\n  max-width: 80%;\n  max-height: 570px;\n  padding-bottom: 15px;\n  /* padding-left: 50px;\n  padding-right: 50px; */\n}\n\n.large-parent-div .large-sliders-container .top-header {\n  max-height: 90px;\n  padding-left: 190px;\n  padding-right: 170px;\n}\n\n.large-parent-div .large-sliders-container .result-component {\n  max-height: 449px;\n  margin-top: 0px;\n}\n\n.bg-light {\n  background-color: #fff !important;\n}\n\n.sliders-container .swiper-button-next {\n  margin-right: -8px !important;\n  z-index: 10000 !important;\n}\n\n.sliders-container .swiper-button-prev {\n  margin-left: -8px !important;\n  z-index: 10000 !important;\n}\n\n.sliders-container .swiper-button-next,\n.sliders-container .swiper-button-prev {\n  width: 26px !important;\n  height: 26px !important;\n  border-radius: 50%;\n  border: 1px solid #bbb !important;\n  color: #31a6ee !important;\n  background-color: #dadada;\n}\n\n.sliders-container .swiper-button-next:after,\n.sliders-container .swiper-button-prev:after {\n  font-size: 14px !important;\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n}\n\n.large-parent-div .mySwiper {\n  padding: 0px 0;\n  overflow: visible;\n}\n\n.large-parent-div .swiper-slide-active {\n  opacity: 1;\n  z-index: 2;\n  background-color: transparent !important;\n}\n\n.large-parent-div .swiper-slide-prev {\n  opacity: 0.7;\n  position: relative;\n  left: 14rem;\n  bottom: 5rem;\n}\n\n.result-page-card .large-result-component .large {\n  box-shadow:\n    0 10px 20px rgba(0, 0, 0, 0.19),\n    0 6px 6px rgba(0, 0, 0, 0.23);\n  background-color: transparent !important;\n}\n\n.large-card {\n  background-color: transparent !important;\n}\n\n.large-parent-div .swiper-slide-next {\n  opacity: 0.7;\n  position: relative;\n  right: 14rem;\n  bottom: 5rem;\n}\n\n.large-parent-div .slide-content {\n  border-radius: 20px;\n  transition: all 0.3s ease;\n  height: 100%;\n}\n\n.large-parent-div .swiper-container {\n  overflow: visible;\n}\n\n.sliders-container .swiper-pagination {\n  display: flex !important;\n  justify-content: space-between !important;\n  max-width: 392px !important;\n  left: 2.88rem !important;\n  height: 30px;\n  top: 7rem !important;\n  z-index: 1 !important;\n}\n\n/* if back button is not availble use this for pagination adjustment */\n.sliders-container.doktor-swiper-pagination .swiper-pagination {\n  display: flex !important;\n  justify-content: space-between !important;\n  max-width: 392px !important;\n  left: 2.88rem !important;\n  height: 30px;\n  top: 6rem !important;\n  z-index: 1 !important;\n}\n\n.sliders-container .swiper-pagination-bullet {\n  border-radius: 0 !important;\n  width: 100% !important;\n  height: 3.33px !important;\n}\n\n.sliders-container .swiper-pagination-bullet:hover,\n.sliders-container .swiper-pagination-bullet-active {\n  background: #717171 !important;\n}\n.large-sliders-container .swiper-button-next {\n  margin-right: -8px !important;\n  z-index: 10000 !important;\n}\n\n.large-sliders-container .swiper-button-prev {\n  margin-left: -8px !important;\n  z-index: 10000 !important;\n}\n\n.large-sliders-container .swiper-button-next,\n.large-sliders-container .swiper-button-prev {\n  width: 26px !important;\n  height: 26px !important;\n  border-radius: 50%;\n  border: 1px solid #bbb !important;\n  color: #fff !important;\n  background-color: #b1aaaa;\n}\n\n.large {\n  min-width: 400px;\n  height: 300px;\n  padding: 0px;\n}\n\n.large-sliders-container .swiper-button-next:after,\n.large-sliders-container .swiper-button-prev:after {\n  font-size: 14px !important;\n  text-transform: none !important;\n  letter-spacing: 0;\n  font-variant: initial;\n  line-height: 1;\n}\n\n.large-sliders-container .swiper-pagination {\n  display: flex !important;\n  justify-content: space-between !important;\n  min-width: 100% !important;\n  left: 2.88rem !important;\n  height: 30px;\n  top: 1px !important;\n  z-index: 1 !important;\n}\n\n.large-sliders-container .swiper-pagination-bullet {\n  border-radius: 0 !important;\n  width: 100% !important;\n  height: 3.33px !important;\n}\n\n.large-sliders-container .swiper-pagination-bullet:hover,\n.large-sliders-container .swiper-pagination-bullet-active {\n  background: #717171 !important;\n}\n\n.sliders-container .swiper-slide {\n  transform: translate3d(10px) !important;\n}\n\n/* this will handle pagination line distance from top when given condition met */\n@media (min-width: 500px) and (max-width: 1200px) {\n  .sliders-container .swiper-pagination {\n    top: 121px !important;\n  }\n}\n@media (max-width: 500px) {\n  .sliders-container .swiper-button-next,\n  .sliders-container .swiper-button-prev {\n    display: none !important;\n  }\n\n  .sliders-container .swiper {\n    max-width: 100% !important;\n  }\n\n  .sliders-container .swiper-pagination {\n    max-width: 87% !important;\n    left: 1.66rem !important;\n    top: 96px !important;\n    height: 30px;\n  }\n\n  /* if back button is not availble use this for pagination adjustment */\n  .sliders-container.doktor-swiper-pagination .swiper-pagination {\n    max-width: 87% !important;\n    left: 1.66rem !important;\n    /* top: 4rem !important; */\n    top: 60px !important;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
